import { ISize } from "../MyHelpers";
import { CometStyles, DisplayAmount, FillingPotFeature, FitType, ISettings, InfoScreenSlider, JackpotDisplay, JackpotDisplayType, MenuType, PanelType, Presentation, Screen3SettingDisplay, ScreenConfiguration, ScreenHeightType, ScreenWidthType, SourcePickbonus, VirtualBotoneraType, WallDisplayType, WarningMessage, WinLinesType } from "../Settings";


export class Classic implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_Online_Classic";

    public readonly ShowLastBigCard: boolean = false;
    public readonly fillingPotFeature: FillingPotFeature = FillingPotFeature.Disable;
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStylePIXI;
    public readonly autoPlaySkipWinLines: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.PaytableJackpotDisplay;
    public readonly MenuType : MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.OnlineResponsive5buttons1Line;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 540;
	public readonly ScreenWidth: ScreenWidthType = 960;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly EnablePanelWithSettings = false;

    //public readonly ResourcesFolder: string = "/frontend-resources/beta/";//"https://usc1.contabostorage.com/0767d0a9352c40aaa7861aabdc75d4ec:beta-resources/online-720-fillingPot/";//"https://usc1.contabostorage.com/0fe075d87e7e4bb9a28324b884177cb2:resources/staging/";
    public readonly ResourcesFolder: string = "/frontend-resources/beta/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = true;
    public readonly EndlessFitting: boolean = true;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.Image;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    //public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;
     //public readonly Server: string = "{protocol}//{host}/backend/singlegame";
    ///*Local Server*/  public readonly Server: string = "{protocol}//{hostname}:5006";
    ///*Production Server*/
    public readonly Server: string = "{protocol}//{host}";

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "fit";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".mp3";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.GameTitleJackpot; 
}
